import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { Editor } from '@tinymce/tinymce-react';

const RichTextEditor = forwardRef(({ value, onChange }, ref) => {
  const editorRef = useRef(null);

  useImperativeHandle(ref, () => ({
    triggerPreview: () => {
      if (editorRef.current) editorRef.current.execCommand('mcePreview');
    }
  }));

  return (
    <Editor
      apiKey="rv620ys55qn2qvrafdlx5ftp7doeu9f2jukubanpb36fkuiw"
      value={value}
      onInit={(evt, editor) => {
        editorRef.current = editor;

        editor.ui.registry.addButton('insertProjectImage', {
          icon: 'image',
          tooltip: 'Insert Project Image',
          onAction: () => {
            window.selectImageForEditor = (url, caption = '', width = '80%') => {
              if (!editorRef.current) return;

              const figureHtml = `
                <figure style="text-align:center; margin:1rem 0;">
                  <img src="${url}" alt="${caption}" style="max-width:${width}; height:auto;" />
                  <figcaption style="font-size:0.85em; color:#666; margin-top:0.25rem;">${caption}</figcaption>
                </figure>
              `;

              editorRef.current.selection.setContent(figureHtml);
            };

            window.dispatchEvent(new CustomEvent('openProjectImagePicker'));
          }
        });
      }}
      init={{
        height: 500,
        menubar: true,
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'image', 'preview', 'anchor',
          'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime',
          'media', 'table', 'help', 'wordcount'
        ],
        toolbar:
          'undo redo | blocks | bold italic underline | alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist | link insertProjectImage table | forecolor backcolor | removeformat | code preview fullscreen',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        branding: false,
        valid_elements: '*[*]',
        extended_valid_elements: 'figure[class|style],figcaption[class|style],img[class|src|alt|width|height|style]',
        forced_root_block: false
      }}
      onEditorChange={(content) => onChange(content)}
    />
  );
});

export default RichTextEditor;
